import script from "./LocationsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./LocationsPage.vue?vue&type=script&setup=true&lang=js"

import "./LocationsPage.vue?vue&type=style&index=0&id=73f8ea20&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\Code\\GK\\MulticaseWeb\\MulticaseWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73f8ea20"]])

export default __exports__